"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var coveo_search_ui_1 = require("coveo-search-ui");
var SearchEndpoint = (function () {
    function SearchEndpoint() {
    }
    SearchEndpoint.configureSitecoreEndpoint = function (options) {
        if (typeof (options) === "undefined") {
            throw Error("You must define endpoint options when calling 'configureSitecoreEndpoint'.");
        }
        coveo_search_ui_1.SearchEndpoint.endpoints["default"] = SearchEndpoint.createNewEndpoint(options);
    };
    SearchEndpoint.createNewEndpoint = function (options) {
        return new coveo_search_ui_1.SearchEndpoint({
            restUri: options.restEndpointUri || "/coveo/rest",
            queryStringArguments: {
                "sitecoreItemUri": options.itemUri,
                "siteName": options.siteName
            }
        });
    };
    return SearchEndpoint;
}());
exports.SearchEndpoint = SearchEndpoint;



//////////////////
// WEBPACK FOOTER
// ./src/base/SearchEndpoint.ts
// module id = 28
// module chunks = 13 14